import { UntitledIcon } from '@faceup/icons'
import { ulStar01 } from '@faceup/icons/ulStar01'
import { usStar01 } from '@faceup/icons/usStar01'
import { Rate, type RateProps, Typography } from '@faceup/ui-base'
import { forwardRef, useState } from 'react'
import './assets/surveyRate.css'

// biome-ignore lint/suspicious/noExplicitAny: Generic type parameter requires any
export const SurveyRate = forwardRef<any, RateProps>((props, ref) => {
  const [hoverValue, setHoverValue] = useState<number | undefined>()
  return (
    <Rate
      ref={ref}
      onHoverChange={setHoverValue}
      character={characterProps => {
        const isHovered =
          (hoverValue !== undefined &&
            characterProps.index !== undefined &&
            characterProps.index < hoverValue) ||
          (characterProps.value !== undefined &&
            characterProps.index !== undefined &&
            characterProps.index < characterProps.value)
        return isHovered ? (
          <UntitledIcon icon={usStar01} size={24} color='#FADB14' />
        ) : (
          <UntitledIcon icon={ulStar01} size={24} color='#6F91B7' />
        )
      }}
      rootClassName='ui-survey-rate'
      characterRender={(value, props) => {
        return (
          <div className='flex flex-col gap-2'>
            {value}
            <div className='ui-survey-rate-text'>
              <Typography.Text>{(props.index || 0) + 1}</Typography.Text>
            </div>
          </div>
        )
      }}
      {...props}
    />
  )
})
